import React from "react";
import { COLORS, RADIUS } from "../../theme";
import Icon from "./Icon";

const TONS = {
  info: { bg: "#CFFAFE", border: "#0891B255", cor: "#0E6377" },
  warning: { bg: COLORS.warningBg, border: `${COLORS.warning}55`, cor: "#92600A" },
  success: { bg: COLORS.successBg, border: "#BBF7D0", cor: COLORS.success },
  danger: { bg: COLORS.dangerBg, border: "#FECACA", cor: COLORS.danger },
};

// Faixa de aviso com ícone — extraído do Bater Ponto, onde 5 blocos quase
// idênticos foram unificados aqui pra reaproveitar em qualquer tela.
export default function Aviso({ tone = "info", icon, onClose, children }) {
  const t = TONS[tone] || TONS.info;
  return (
    <div
      style={{
        display: "flex", alignItems: "center", gap: 10, marginBottom: 12, padding: "11px 14px",
        background: t.bg, border: `1px solid ${t.border}`, borderRadius: RADIUS.md,
      }}
    >
      {icon && <Icon name={icon} size={17} color={t.cor} />}
      <span style={{ fontSize: 13, color: t.cor, fontWeight: 600, flex: 1 }}>{children}</span>
      {onClose && (
        <button
          onClick={onClose}
          aria-label="Fechar aviso"
          style={{ background: "none", border: "none", color: t.cor, fontSize: 16, cursor: "pointer", padding: 0, lineHeight: 1 }}
        >
          ✕
        </button>
      )}
    </div>
  );
}
